import { Table, Card, Button, Form, Input, Select, message, Divider, Popconfirm } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { Component, Fragment } from 'react';
import { PostForm } from '../../utils/http';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      roleIds: [],
      addModal: undefined,
      tableloading: false,
      modalloading: false,
    };
  }
  componentDidMount() {
    this.getData();
    this.getAllRoles();
  }
  columns = [
    {
      title: 'userId',
      dataIndex: 'userId',
    },
    {
      title: 'username',
      dataIndex: 'username',
    },
    {
      title: 'roleIds',
      dataIndex: 'roleIds',
      render: text => text && text.join(),
    },
    {
      title: '操作',
      render: (record) => (
        <Fragment>
          <span className="link" onClick={() => this.setState({ addModal: record })}>编辑</span>
          <Divider type="vertical" />
          <Popconfirm
            placement="leftTop"
            title="确定要删除吗?"
            onConfirm={() => this.handleDelete(record.userId)}
            okText="确定"
            cancelText="取消"
          >
            <span className="link">删除</span>
          </Popconfirm>
        </Fragment>
      )
    },
  ]
  showAddUserModal = () => {
    this.setState({ addModal: {} });
  }
  handleDelete = (userId) => {
    PostForm({
      url: '/api/user/deleteUser',
      data: { userId },
      success: ({ msg }) => {
        message.success(msg);
        this.getData();
      },
      error: ({ msg }) => {
        message.error(msg);
      },
    });
  }
  onFinish = (values) => {
    const { userId, username, roleIds } = values;
    const password = values.password || undefined;
    this.setState({ modalloading: true });
    PostForm({
      url: '/api/user/editUser',
      data: { userId, username, password, roleIds: roleIds.join() },
      success: ({ msg = '操作成功' }) => {
        message.success(msg);
        this.setState({ addModal: false });
        this.getData();
      },
      error: ({ msg = '操作失败' }) => {
        message.error(msg);
      },
      final: () => {
        this.setState({ modalloading: false });
      },
    });
  }
  getAllRoles = () => {
    PostForm({
      url: '/api/user/getAllRoles',
      data: {},
      success: ({ data: { roleIds } = {} }) => {
        this.setState({ roleIds })
      },
    });
  }
  getData = () => {
    this.setState({ tableloading: true });
    PostForm({
      url: '/api/user/getAllUsers',
      data: {},
      success: ({ data: { users } = {} }) => {
        this.setState({ users })
      },
      final: () => {
        this.setState({ tableloading: false });
      },
    });
  }
  render() {
    const { users, addModal, tableloading, modalloading, roleIds } = this.state;
    return (
      <Card extra={
        <Button type="primary" size="small" onClick={this.showAddUserModal}>
          新增
        </Button>}
      >
        <Table
          dataSource={users}
          columns={this.columns}
          pagination={false}
          loading={tableloading}
          rowKey="userId"
          size="small"
        />
        {
          addModal && (
            <Modal
              visible={true}
              onCancel={() => { this.setState({ addModal: false })}}
              footer={null}
              width={400}
            >
              <Form
                {...layout}
                name="basic"
                initialValues={{
                  userId: addModal.userId || '',
                  username: addModal.username || '',
                  password: addModal.password || '',
                  roleIds: addModal.roleIds || [],
                }}
                onFinish={this.onFinish}
              >
                <Form.Item
                  label="用户ID"
                  name="userId"
                  rules={[{ required: true, message: '请输入用户ID!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="用户姓名"
                  name="username"
                  rules={[{ required: true, message: '请输入用户名!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="用户密码"
                  name="password"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="角色"
                  name="roleIds"
                  rules={[{ required: true, message: '请选择角色!' }]}
                >
                  <Select
                    mode="multiple"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.split('.')[0].toLowerCase()) >= 0
                    }
                  >
                    {
                      roleIds.map(({ roleId, roleName}) => (
                        <Select.Option key={roleId} value={roleId}>
                          { roleName || roleId }
                        </Select.Option>
                      ))
                    }
                  </Select>
                </Form.Item>
                <div style={{ textAlign: 'right', paddingRight: 30 }}>
                  <Button loading={modalloading} type="primary" htmlType="submit">
                    提交
                  </Button>
                </div>
              </Form>
            </Modal>
          )
        }
      </Card>
    )
  }
}

export default UserList;